/**
 * Функция для расчета размеров внутреннего контейнера (например, изображения) с учетом соотношения сторон.
 * Позволяет сохранить пропорции изображения, чтобы оно вписывалось в заданные размеры контейнера.
 *
 * @param {number} imageWidth - Ширина изображения.
 * @param {number} imageHeight - Высота изображения.
 * @param {number} containerWidth - Ширина контейнера, в который нужно вписать изображение.
 * @param {number} containerHeight - Высота контейнера, в который нужно вписать изображение.
 * @returns {{ width: number | string; height: number | string }} - Объект с рассчитанными шириной и высотой.
 *   Если ширина или высота изображения равны 0, возвращает { width: '100%', height: '100%' }.
 */

export const calculateInnerBoxDimensions = (
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number,
) => {
  if (imageWidth === 0 || imageHeight === 0) {
    return { width: '100%', height: '100%' };
  }

  const imageAspectRatio = imageWidth / imageHeight;
  const containerAspectRatio = containerWidth / containerHeight;

  if (imageAspectRatio > containerAspectRatio) {
    const calculatedHeight = containerWidth / imageAspectRatio;
    return { width: containerWidth, height: calculatedHeight };
  } else {
    const calculatedWidth = containerHeight * imageAspectRatio;
    return { width: calculatedWidth, height: containerHeight };
  }
};
